export const footerBarClassName = 'sdsm-footer-bar';
export const footerBarContainerClassName = 'sdsm-footer-bar-container';
export const footerBarWrapperClassName = 'sdsm-footer-bar-wrapper';
export const footerColumnsDesktopWrapperClassName = 'sdsm-footer-columns-desktop-wrapper';
export const footerColumnsDesktopContainerClassName = 'sdsm-footer-columns-desktop-container';
export const footerSocialWrapperClassName = 'sdsm-footer-social-wrapper';
export const footerSocialClassName = 'sdsm-footer-social';
